import commonDefinitions from "../components/common-definitions"
import { start } from "../components/core"
import AdvancedPassword from "../components/shared/inputs/password/advanced-password"
import HomeP3 from "../components/shared/home_p3/home_p3"
import Candidatures from "../components/shared/home_p3/candidatures-home"
import CandidaturesItem from "../components/shared/home_p3/candidatures-item"
import Messages from "../components/shared/home_p3/messages-home"
import MessageItem from "../components/shared/home_p3/message-home"
import DataSerp from "../components/shared/serp-dynamic/serp-dynamic"
import SerpOffer from "../components/shared/serp-dynamic/serp-offer-dynamic"
import AlertesHome from "../components/shared/home_p3/alertes-home"
import AlertesListe from "../components/shared/home_p3/alertes-liste"
import AlertesCriteres from "../components/shared/home_p3/alertes-criteres"
import AlertesVide from "../components/shared/home_p3/alertes-vide"
import ProgressButton from "../components/shared/progress-button/progress-button"
import SignIn from "../components/shared/sign-form/sign-in"
import SignUp from "../components/shared/sign-form/sign-up"
import ProfileMessagesList from "../components/shared/profile-messages/profile-messages-list"
import ProfileMessageIntermediation from "../components/shared/profile-messages/profile-messages-intermediation"
import ProfileMessageCvSeen from "../components/shared/profile-messages/profile-messages-cv-seen"
import ProfileSubscriptions from "../components/shared/profile-alerts/profile-subscription"
import ProfileAlertsList from "../components/shared/profile-alerts/profile-alerts-list"
import ProfileAlert from "../components/shared/profile-alerts/profile-alert"
import SimpleSelect from "../components/shared/inputs/simple-select/simple-select"
import ProfileCv from "../components/shared/profile/cv/profile-cv"
import ProfileContainer from "../components/shared/profile/forms/container/profile-container"
import ProfileInformations from "../components/shared/profile/informations/profile-informations"
import NavElement from "../components/shared/profile/navigation/nav-element"
import NavList from "../components/shared/profile/navigation/nav-list"
import ProfilePersonal from "../components/shared/profile/personal/profile-personal"
import ProfileSituation from "../components/shared/profile/situation/profile-situation"
import ProfileSearch from "../components/shared/profile/search/profile-search"
import RadioToggle from "../components/shared/helpers/radio-toggle"
import BinderGeneric from "../components/shared/binder/binder"
import FacetsEngine from "../components/shared/facets-engine/facets-engine"
import { messageRebond } from "../components/shared/message/message"

start({
  ...commonDefinitions,
  "advanced-password": AdvancedPassword,
  "alertes-criteres": AlertesCriteres,
  "alerte-home": AlertesHome,
  "alertes-liste": AlertesListe,
  "alertes-vide": AlertesVide,
  "binder-gen": BinderGeneric,
  "candidatures-home": Candidatures,
  "candidatures-item": CandidaturesItem,
  "engine-facets": FacetsEngine,
  "home-p3": HomeP3,
  messages: Messages,
  "message-item": MessageItem,
  "profile-alerts-list": ProfileAlertsList,
  "profile-alert": ProfileAlert,
  "profile-message-cv-seen": ProfileMessageCvSeen,
  "profile-message-intermediation": ProfileMessageIntermediation,
  "profile-messages-list": ProfileMessagesList,
  "profile-subscriptions": ProfileSubscriptions,
  progressbutton: ProgressButton,
  "profile-container": ProfileContainer,
  "profile-cv": ProfileCv,
  "profile-informations": ProfileInformations,
  "profile-nav-element": NavElement,
  "profile-nav-list": NavList,
  "profile-personal": ProfilePersonal,
  "profile-search": ProfileSearch,
  "profile-situation": ProfileSituation,
  radiotoggle: RadioToggle,
  serp: DataSerp,
  "serp-offer": SerpOffer,
  "sign-in": SignIn,
  "sign-up": SignUp,
  "simple-select": SimpleSelect,
})
messageRebond()
